<<template>
  <div class="detail-panel">
    <div class="btn-panel">
        <a v-if="this.action != 'View'" class="btn btn-default" @click="save">{{$rs["btn_save"]}}</a>
      <slot></slot>
        <a v-if="this.action == 'Edit'" class="btn btn-default" @click="readCard">{{rs["readCard"]}}</a>
        <a v-if="this.action == 'Edit'" class="btn btn-default" @click="cFinger">{{rs["cFinger"]}}</a>
        <a v-if="this.action != 'View'" class="btn btn-default" @click="takePhoto">{{rs["takePhoto"]}}</a>
        <a v-if="this.action == 'Edit'" class="btn btn-default" @click="regCard">{{rs["regCard"]}}</a>
    </div>
      <hr>
    <div class="content">
      <div class="poto-panel">
        <img ref="mImg" v-bind:src="imgPath"/>
        <input ref="imgFile" type="file" @change="selImg"/>
      </div>
      
      <div class="row" >
          <div class="input-group col-md-2">
            <span class="input-group-addon" >{{rs["companyNo"]}}</span>
            <select class="form-control" v-model="companyNo">
              <option v-for="(item, idx) in config.company" :value='item.value'>{{item.text}}</option>
            </select>
          </div>
          <div class="input-group col-md-2">
            <span class="input-group-addon" >{{rs["empId"]}}</span>
            <input type="text" class="form-control"  readonly='true' v-model="data.empId">
          </div>
          <div class="input-group col-md-2">
            <span class="input-group-addon" >{{rs["empName"]}}</span>
            <input type="text" class="form-control"  v-bind:readonly='action=="View"' v-model="data.empName">
          </div>
        <div class="input-group col-md-2">
          <span class="input-group-addon" >{{rs["sex"]}}</span>
          <select v-model="data.sex" v-bind:disabled='action=="View"' class="form-control">
            <option value="1">{{rs["sex1"]}}</option>
            <option value="2">{{rs["sex2"]}}</option>
          </select>
        </div>
        <div class="input-group col-md-2">
          <span class="input-group-addon" >{{rs["deptNo"]}}</span>
          <select  v-model="deptNo" v-bind:disabled='action=="View"' class="form-control">
            <option v-for='item in config.dept' :value='item.deptNo'>{{item.deptName}}</option>
          </select>
        </div>
        <div class="input-group col-md-2">
          <span class="input-group-addon" >{{rs["xgroup"]}}</span>
          <select v-model="data.xgroup" v-bind:disabled='action=="View"' class="form-control">
            <option value='' selected>---</option>
            <option v-for='item in xgroup' :value='item'>{{item}}</option>
          </select>
        </div>
        <div class="input-group col-md-2">
          <span class="input-group-addon" >{{rs["duty"]}}</span>
              <select v-model="data['duty']" class="form-control"  v-bind:disabled='action=="View"'>
                  <option v-for='item in config.duty' :value="item">{{item}}</option>
              </select>
        </div>
        <div class="input-group col-md-2">
          <span class="input-group-addon" >{{rs["jobTitle"]}}</span>
          <select v-model="data['jobTitle']" class="form-control"  v-bind:disabled='action=="View"'>
              <option v-for='item in config.jobTitle' :value="item">{{item}}</option>
          </select>
        </div>
        <div class="input-group col-md-2">
          <span class="input-group-addon" >{{rs["job"]}}</span>
              <select v-model="data.job" class="form-control"  v-bind:disabled='action=="View"'>
                  <option v-for='item in xjob' :value="item">{{item}}</option>
              </select>
        </div>
        <div class="input-group col-md-2">
          <span class="input-group-addon" >{{rs["shiftNo"]}}</span>
          <select v-model="data.shiftNo" v-bind:disabled='action=="View"' class="form-control">
            <option v-for='item in config.bc' :value='item.shiftNo'>{{item.shiftName}}</option>
          </select>
        </div>
        <div class="input-group col-md-2">
          <span class="input-group-addon" >{{rs["groupNo"]}}</span>
          <select v-model="data.groupNo" v-bind:disabled='action=="View"' class="form-control">
            <option value='' selected>---</option>
            <option v-for='item in config.bz' :value='item.groupNo'>{{item.groupName}}</option>
          </select>
        </div>
        <div class="input-group col-md-2">
          <span class="input-group-addon" >{{rs["planNo"]}}</span>
          <select v-model="data.planNo" v-bind:disabled='action=="View"' class="form-control">
            <option v-for='item in config.plan' :value='item.planNo'>{{item.planName}}</option>
          </select>
        </div>
        <div class="input-group col-md-2">
          <span class="input-group-addon" >{{rs["attVerifyType"]}}</span>
            <select v-model="data.attVerifyType" class="form-control"  v-bind:disabled='action=="View"'>
              <option value="1">{{rs["attVerifyType1"]}}</option>
              <option value="2">{{rs["attVerifyType2"]}}</option>
              <option value="3">{{rs["attVerifyType3"]}}</option>
            </select>
        </div>
        <div class="input-group col-md-2">
          <span class="input-group-addon" >{{rs["accessControlNo"]}}</span>
          <select v-model="data.accessControlNo" v-bind:disabled='action=="View"' class="form-control">
            <option value='' selected>---</option> 
            <option v-for='item in config.accessControl' :value='item.planNo'>{{item.planName}}</option>
          </select>
        </div>
        <div class="input-group col-md-2">
          <span class="input-group-addon" >{{rs["accVerifyType"]}}</span>
            <select v-model="data.accVerifyType" class="form-control"  v-bind:disabled='action=="View"'>
              <option value="1">{{rs["accVerifyType1"]}}</option>
              <option value="2">{{rs["accVerifyType2"]}}</option>
              <option value="3">{{rs["accVerifyType3"]}}</option>
            </select>
        </div>
        <div class="input-group col-md-2">
          <span class="input-group-addon" >{{rs["status"]}}</span>
              <select v-model="data.status" class="form-control"  v-bind:disabled='action=="View"'>
                  <option value="1">{{rs["status1"]}}</option>
                  <option value="2">{{rs["status2"]}}</option>
              </select>
        </div>
        <div v-if='data.status != "1"' class="input-group col-md-2">
          <span class="input-group-addon" >{{rs["departureDate"]}}</span>
          <date-input class="form-control"  v-bind:readonly='action=="View"' v-model="data.departureDate" />
        </div>
        <div v-if='data.status != 1' class="input-group col-md-2">
          <span class="input-group-addon" >{{rs["departureReason"]}}</span>
          <input type="text" class="form-control"  v-bind:readonly='action=="View"' v-model="data.departureReason" >
        </div>
        <div v-if='data.status != 1' class="input-group col-md-2">
          <span class="input-group-addon" >{{rs["departureType"]}}</span>
            <select name="departureType" v-model="data.departureType" v-bind:disabled='action=="View"' class="data-field form-control" style="width:153px">
              <option value="1">{{rs["dw1"]}}</option>
              <option value="2">{{rs["dw2"]}}</option>
              <option value="3">{{rs["dw3"]}}</option>
              <option value="4">{{rs["dw4"]}}</option>
              <option value="5">{{rs["dw5"]}}</option>
              <option value="6">{{rs["dw6"]}}</option>
              <option value="7">{{rs["dw7"]}}</option>
              <option value="8">{{rs["dw8"]}}</option>
              <option value="9">{{rs["dw9"]}}</option>
            </select>
          <label class="input-group-addon"><input type="checkbox" id="blacklist" v-model="data.isblack" />{{rs["isblack"]}}</label>
        </div>
      </div>

      <ul id="empTabs" class="nav nav-tabs" style="margin-left: 5px; overflow: hidden;">
        <li role="presentation" :class='showTabs==1?"active":""'><a @click="setShowTabs(1)" class="emp-tabs" href="javascript:">{{rs["qt"]}}</a></li>
        <!--li role="presentation" :class='showTabs==2?"active":""'><a @click="setShowTabs(2)" class="emp-tabs" href="javascript:">{{rs["xz"]}}</a></li-->
        <li role="presentation" :class='showTabs==3?"active":""'><a @click="setShowTabs(3)" class="emp-tabs" href="javascript:">{{rs["gr"]}}</a></li>
        <li role="presentation" :class='showTabs==4?"active":""'><a @click="setShowTabs(4)" class="emp-tabs" href="javascript:">{{rs["contract"]}}</a></li>
      </ul>
      <div v-show="showTabs==1" class="tabs tabs-gr">
        <br>
        <div class="row" >    
          <div class="input-group col-md-2">
            <span class="input-group-addon" >{{rs["arriveDate"]}}</span>
            <date-input v-model="arriveDate" v-bind:readonly='action=="View"' class="form-control"/>
          </div>
          <div class="input-group col-md-2">
            <span class="input-group-addon" >{{rs["probationMonth"]}}</span>
            <input type="number" v-model="probationMonth" v-bind:readonly='action=="View"' class="form-control">
          </div>
          <div class="input-group col-md-2">
            <span class="input-group-addon" >{{rs["probationEndDate"]}}</span>
            <date-input v-model="data.probationEndDate" v-bind:readonly='action=="View"' class="form-control"/>
          </div>
          <div class="input-group col-md-2">
            <span class="input-group-addon" >{{rs["workMonth"]}}</span>
            <input type="text" class="form-control"  v-bind:readonly='action=="View"' v-model="data.workMonth" >
          </div>
          <div class="input-group col-md-2">
            <span class="input-group-addon" >{{rs["age"]}}</span>
            <input type="text" class="form-control"  v-bind:readonly='action=="View"' v-model="data.age" >
          </div>
          <div class="input-group col-md-2">
            <span class="input-group-addon" >{{rs["startAge"]}}</span>
            <input type="text" class="form-control"  v-bind:readonly='action=="View"' v-model="data.startAge" >
          </div>
          <div class="input-group col-md-2">
            <span class="input-group-addon" >{{rs["introducer"]}}</span>
            <input type="text" class="form-control"  v-bind:readonly='action=="View"' v-model="data.introducer" >
          </div>    
          <div class="input-group col-md-2">
            <span class="input-group-addon" >{{rs["stemFrom"]}}</span>
            <input type="text" class="form-control"  v-bind:readonly='action=="View"' v-model="data.stemFrom" >
          </div>
          <div class="input-group col-md-2"><span class="input-group-addon" >{{rs["newOrReplace"]}}</span>
            <input type="text" class="form-control"  v-bind:readonly='action=="View"' v-model="data.newOrReplace" >
          </div>  
          <div class="input-group col-md-2"><span class="input-group-addon" >{{rs["physicalDate"]}}</span>
            <date-input v-model="data.physicalDate" v-bind:readonly='action=="View"' class="form-control"/>
          </div>  
          <div class="input-group col-md-2"><span class="input-group-addon" >{{rs["socialSecurity"]}}</span>
                <select  v-model="data.socialSecurity" v-bind:disabled='action=="View"' class="form-control">
                  <option value="0">{{rs["socialSecurity0"]}}</option>
                  <option value="1">{{rs["socialSecurity1"]}}</option>
                </select>
          </div>
          <div class="input-group col-md-2">
            <span class="input-group-addon" >{{rs["fingerStatus"]}}</span>
                <select  v-model="data.fingerStatus" v-bind:disabled='action=="View"' class="form-control">
                  <option value="0">{{rs["fingerStatus0"]}}</option>
                  <option value="1">{{rs["fingerStatus1"]}}</option>
                  <option value="2">{{rs["fingerStatus2"]}}</option>
                </select>
          </div>
          <div class="input-group col-md-2">
            <span class="input-group-addon" >{{rs["faceStatus"]}}</span>
                <select  v-model="data.faceStatus" v-bind:disabled='action=="View"' class="form-control">
                  <option value="0">{{rs["faceStatus0"]}}</option>
                  <option value="1">{{rs["faceStatus1"]}}</option>
                  <option value="2">{{rs["faceStatus2"]}}</option>
                  <option value="3">{{rs["faceStatus3"]}}</option>
                </select>
          </div>
          <div class="input-group col-md-2"><span class="input-group-addon" >{{rs["restDays"]}}</span>
            <input type="number" class="form-control"  v-bind:readonly='action=="View"' v-model="data.restDays" >
          </div>
        </div>
        <div class="row">
          <div class="input-group col-md-4"><span class="input-group-addon" >{{rs["bankAccount"]}}</span>
            <input type="text" class="form-control"  v-bind:readonly='action=="View"' v-model="data.bankAccount" >
          </div>
          <div class="input-group col-md-4"><span class="input-group-addon" >{{rs["bankName"]}}</span>
            <input type="text" class="form-control"  v-bind:readonly='action=="View"' v-model="data.bankName" >
          </div>  
        </div>
      </div>
      <div v-show="showTabs==2" class="tabs tabs-xz">
        <br>
        <div class="row">
          <div class="input-group col-md-2"><span class="input-group-addon" >{{rs["salaryBase"]}}</span>
            <input type="number" class="form-control"  v-bind:readonly='action=="View"' v-model="data.salaryBase" >
          </div>  
          <div class="input-group col-md-2"><span class="input-group-addon" >{{rs["salaryPost"]}}</span>
            <input type="number" class="form-control"  v-bind:readonly='action=="View"' v-model="data.salaryPost" >
          </div>  
          <!--div class="input-group col-md-2"><span class="input-group-addon" >{{rs["restDays"]}}</span>
            <input type="number" class="form-control"  v-bind:readonly='action=="View"' v-model="data.restDays" >
          </div-->  
        </div>
        <div class="row">
            <div class="input-group col-md-2"><span class="input-group-addon" >{{rs["salaryType"]}}</span>
              <select  v-model="data.salaryType" v-bind:disabled='action=="View"' class="form-control">
                <option value="1">月薪</option>
                <option value="2">件薪</option>
                <option value="3">日薪</option>
                <option value="4">时薪</option>
              </select>
            </div>
            <div class="input-group col-md-2"><span class="input-group-addon" >{{rs["salaryMethod"]}}</span>
            
              <select v-model="data.salaryMethod" v-bind:disabled='action=="View"' class="form-control">
                <option value="1.月薪1">1.月薪1</option>
                <option value="2.月薪2">2.月薪2</option>
                <option value="3.月薪3">3.月薪3</option>
                <option value="4.月薪4">4.月薪4</option>
                <option value="5.时工1">5.时工1</option>
                <option value="6.时工2">6.时工2</option>
                <option value="7.件工1">7.件工1</option>
                <option value="8.件工2">8.件工2</option>
                <option value="9.件工3">9.件工3</option>
              </select>
            </div>
          <div class="input-group col-md-2"><span class="input-group-addon" >{{rs["foodSubsidy"]}}</span>
            <input type="number" class="form-control"  v-bind:readonly='action=="View"' v-model="data.foodSubsidy" >
          </div> 
        </div>
        <!--div class="row">
          <div class="input-group col-md-4"><span class="input-group-addon" >{{rs["bankAccount"]}}</span>
            <input type="text" class="form-control"  v-bind:readonly='action=="View"' v-model="data.bankAccount" >
          </div>  
        </div>
        <div class="row">
          <div class="input-group col-md-4"><span class="input-group-addon" >{{rs["bankName"]}}</span>
            <input type="text" class="form-control"  v-bind:readonly='action=="View"' v-model="data.bankName" >
          </div>  
        </div-->

      </div>
      <div v-show="showTabs==3" class="tabs tabs-qt">
        <br>
        <div class="row">
          
        <div class="input-group col-md-2">
          <span class="input-group-addon" >{{rs["idCardNo"]}}</span>
          <input v-model="data.idCardNo"  v-bind:readonly='action=="View"' type="text" class="form-control">
        </div>
        <div class="input-group col-md-2">
          <span class="input-group-addon" >{{rs["periodOfValidity"]}}</span>
          <date-input v-model="data.periodOfValidity" v-bind:readonly='action=="View"' class="form-control"/>
        </div>
        <div class="input-group col-md-2">
          <span class="input-group-addon" >{{rs["address"]}}</span>
          <input v-model="data.address" type="text" class="form-control"  v-bind:readonly='action=="View"' style="width: 440px;">
        </div>
        <div class="input-group col-md-2">
          <span class="input-group-addon" >{{rs["native"]}}</span>
          <input type="text" class="form-control"  v-bind:readonly='action=="View"' v-model="data.native">
        </div>
        <div class="input-group col-md-2"><span class="input-group-addon" >{{rs["phone"]}}</span>
          <input type="text" v-model="data.phone" v-bind:readonly='action=="View"' class="form-control"></div>
          <div class="input-group col-md-2">
            <span class="input-group-addon" >{{rs["marriage"]}}</span>
            <select v-model='data.marriage' v-bind:disabled='action=="View"' class="form-control">
              <option value="0">{{rs["hf0"]}}</option>
              <option value="1">{{rs["hf1"]}}</option>
              <option value="2">{{rs["hf2"]}}</option>
              <option value="3">{{rs["hf3"]}}</option>
            </select>
          </div>
          <div class="input-group col-md-2"><span class="input-group-addon" >{{rs["birthday"]}}</span>
          <date-input v-model="data.birthday" v-bind:readonly='action=="View"' class="form-control"/></div>
          
        <div class="input-group col-md-2">
          <span class="input-group-addon" >{{rs["graduateSchool"]}}</span>
          <input type="text" class="form-control"  v-bind:readonly='action=="View"' v-model="data.graduateSchool">
        </div>
        <div class="input-group col-md-2">
          <span class="input-group-addon" >{{rs["major"]}}</span>
          <input type="text" class="form-control"  v-bind:readonly='action=="View"' v-model="data.major">
        </div>
          <div class="input-group col-md-2"><span class="input-group-addon" >{{rs["education"]}}</span>
            <select v-model='data.education' v-bind:disabled='action=="View"' class="form-control">
              <option value="education1">{{rs["education1"]}}</option>
              <option value="education2">{{rs["education2"]}}</option>
              <option value="education3">{{rs["education3"]}}</option>
              <option value="education4">{{rs["education4"]}}</option>
              <option value="education5" selected="true">{{rs["education5"]}}</option>
              <option value="education6">{{rs["education6"]}}</option>
              <option value="education7">{{rs["education7"]}}</option>
              <option value="education8">{{rs["education8"]}}</option>
            </select>
          </div>
          <div class="input-group col-md-2"><span class="input-group-addon" >{{rs["political"]}}</span>
          <input type="text" v-model="data.political" v-bind:readonly='action=="View"' class="form-control"></div>
          <div class="input-group col-md-2">
            <span class="input-group-addon" >{{rs["nation"]}}</span>
            <select v-model='data["nation"]' v-bind:disabled='action=="View"' class="form-control">
              <option v-for='item in rs["ybms"]' :value="item">{{item}}</option>
            </select>
          </div>
            <div class="input-group col-md-2"><span class="input-group-addon" >{{rs["homeplace"]}}</span>
            <input type="text" v-model="data.homeplace" v-bind:readonly='action=="View"' class="form-control"></div>        
          <div class="input-group col-md-2"><span class="input-group-addon" >{{rs["residenceAddress"]}}</span>
            <input type="text" v-model="data.residenceAddress" v-bind:readonly='action=="View"' class="form-control"></div>
          <div class="input-group col-md-2">
            <span class="input-group-addon" >{{rs["consultantName"]}}</span>
            <input v-model="data.consultantName" type="text" class="form-control"  v-bind:readonly='action=="View"' >
          </div>
          <div class="input-group col-md-2">
            <span class="input-group-addon" >{{rs["consultantPhone"]}}</span>
            <input type="text" class="form-control"  v-bind:readonly='action=="View"' v-model="data.consultantPhone" >
          </div>

  <div class="input-group col-md-2">
             <span class="input-group-addon" >{{rs["is_show"]}}<input type="checkbox" id="isshow" v-model="data.is_show" /></span>
          </div>

           <div class="input-group col-md-2">
          <span class="input-group-addon" >{{rs["shiftNoB"]}}</span>
          <select v-model="data.shiftNo_B" v-bind:disabled='action=="View"' class="form-control">
            <option v-for='item in config.bc' :value='item.shiftNo'>{{item.shiftName}}</option>
          </select>
        </div>

        <div class="input-group col-md-2">
          <span class="input-group-addon" >{{rs["groupNoB"]}}</span>
          <select v-model="data.groupNo_B" v-bind:disabled='action=="View"' class="form-control">
            <option value='' selected>---</option>
            <option v-for='item in config.bz' :value='item.groupNo'>{{item.groupName}}</option>
          </select>
        </div>

          <div class="input-group col-md-2">
            <span class="input-group-addon" >{{rs["filiaction"]}}</span>
            <input v-model="data.filiaction" type="text" class="form-control"  v-bind:readonly='action=="View"' >
          </div>

         

        </div>
      </div>
      <div v-show="showTabs==4" class="tabs tabs-ct">
        <br>
        <div class="row">
          
          <div class="input-group col-md-2">
            <span class="input-group-addon" >{{rs["contractType"]}}</span>
              <select  v-model="data.contractType" v-bind:disabled='action=="View"' class="form-control">
                <option v-for='item in config.contractType' :value="item">{{item}}</option>
              </select>
          </div> 
          <div class="input-group col-md-2">
            <span class="input-group-addon" >{{rs["contractNo"]}}</span>
            <input type="text" class="form-control"  v-bind:readonly='action=="View"' v-model="data.contractNo" >
          </div> 
          <div class="input-group col-md-2"><span class="input-group-addon" >{{rs["contractStartDate"]}}</span>
            <date-input v-model="data.contractStartDate" v-bind:readonly='action=="View"' class="form-control"/></div>
          <div class="input-group col-md-2">
            <span class="input-group-addon" >{{rs["contractPeriod"]}}</span>
            <input type="number" v-model="contractPeriod" v-bind:readonly='action=="View"' class="form-control">
          </div>
          <div class="input-group col-md-2"><span class="input-group-addon" >{{rs["contractEndDate"]}}</span>
            <date-input v-model="data.contractEndDate" v-bind:readonly='action=="View"' class="form-control"/></div>
          <div v-if="false" class="col-md-10" style="margin-left: 10px">
            <div v-if='action!="View"' class="btn-group" role="group" style="margin-top: 5px; margin-bottom: 5px;">
                <button @click.stop="addItem" class="btn btn-default">新增合同</button>
            </div>
            <div size="10" class="col-md-12 " style="height: 300px; overflow: auto;">
              <div class="row">
                <table class="col-md-12 fui-table">
                  <thead>
                    <tr>
                      <th style="width: 50px;">合同类型</th>
                      <th style="width: 50px;">合同状态</th>
                      <th style="width: 50px;">约定岗位</th>
                      <th style="width: 50px;">约定工资</th>
                      <th style="width: 50px;">{{rs["contractStartDate"]}}</th>
                      <th style="width: 50px;">{{rs["contractEndDate"]}}</th>
                      <th style="width: 50px;">合同说明</th>
                    </tr>
                  </thead>
                  <tbody id="qjTimeList">
                    <tr v-for="(item, idx) in times">
                      <td>{{formatter.fdate(item.beginDate)}}</td>
                      <td>{{formatter.fdate(item.endDate)}}</td>
                      <td>{{formatter.ftime(item.beginTime)}}</td>
                      <td>{{formatter.ftime(item.endTime)}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
      <take-photo ref="tph" v-show="showTakePhoto" @close="closeTakePhoto" :img="$refs.mImg" :rs="rs" :detail="data" :url="config.url" />
      <fingerprint id="fingerprint" v-show="showFinger" @close="closeFinger" :finger="fingerList" :rs="rs" :detail="data" :url="config.url" />
      <ic-card id="icCard" v-show="showIC" @close="closeIC" :empId="data.empId" :icCard="data.icNo" :empName="data.empName" :detail="data" :rs="rs" :url="config.url" />
 
  </div>
</template>

<script>
import mixin from "@/fui/mixin";
import takePhoto from "./takePhoto";
import fingerprint from "./fingerprint";
import icCard from "./icCard";
export default {
  created: function() {
    this.data.arriveDate = this.formatter.fdate(this.data.arriveDate);
    this.data.birthday = this.formatter.fdate(this.data.birthday);
    this.data.physicalDate = this.formatter.fdate(this.data.physicalDate);
    this.data.contractStartDate = this.formatter.fdate(this.data.contractStartDate);
    this.data.contractEndDate = this.formatter.fdate(this.data.contractEndDate);
    //this.data.ddr = this.formatter.fdate(this.data.ddr);
    this.data.probationEndDate = this.formatter.fdate(this.data.probationEndDate);
    //this.data.yuyan = this.formatter.fdate(this.data.yuyan);
    this.data.departureDate = this.formatter.fdate(this.data.departureDate);
    this.data.periodOfValidity = this.formatter.fdate(this.data.periodOfValidity);
    if (this.action == "Add" || this.action == "Copy")  {
      this.imgPath = ""
      this.data.status=1
      this.companyNo = this.config.company[0].value
      this.data.companyNo = this.config.company[0].value
      this.data.companyName = this.config.company[0].text
      this.data.fingerStatus = 0
      this.data.faceStatus = 0
      this.data.sex=1
      if (!this.data.deptNo) {
        this.data.deptNo = this.config.dept[0].deptNo
      }
      if (!this.data.marriage) this.data.marriage=0
      this.$getData(this.config.url + "GetBh?cno="+this.companyNo, this.rcBh) 
    }
    else{
      this.imgPath = this.$apiUrl + this.url + "image?bh=" + this.detailData.empId + this.$urlSq()
      this.companyNo = this.data.companyNo
    }
    this.deptNo= this.data.deptNo
    if(!this.data.probationMonth) this.probationMonth = 0
    if (!this.data.attVerifyType) this.data.attVerifyType = 2
    if (!this.data.accVerifyType) this.data.accVerifyType = 1
    this.initDept(this.data.deptNo)
    if (!this.data.planNo) this.data.planNo=1
  },
  data() {
    return {
      //data: this.$extend({}, this.detailData),
      imgPath: "",
      showTabs: 1,
      showTakePhoto: 0,
      showFinger: 0,
      showIC: false,
      fingerList: null,
      ws: null,
      companyNo: 0,
      xgroup:[],
      xjob: [],
      uimg: null,
      ws: null,
      probationMonth: 0,
      contractPeriod: 0,
      deptNo: null
    };
  },
  computed:{
    arriveDate:{
      get(){
        return this.data.arriveDate
      },
      set(v){
        this.data.arriveDate=v
      }
    },
    contractStartDate:{
      get(){
        return this.data.contractStartDate
      },
      set(v){
        this.data.contractStartDate=v
      }
    }
  },
  watch: {
    deptNo(v,o){
      this.data.deptNo = v
      const dept = this.config.dept.filter(d=>{ return d.deptNo==v})
      if (dept && dept.length>0) this.data.deptName = this.config.dept.filter(d=>{ return d.deptNo==v})[0].deptName
      this.initDept(v)
    },
    contractPeriod(val, od){
      this.data.contractPeriod = val
      if (val){
        const pm = val >0? val:0
        const dt = this.$strToDate(this.data.contractStartDate)
        dt.setMonth(dt.getMonth() + parseInt(pm))
        this.data.contractEndDate = this.formatter.fdate(dt)
      }
      //else this.data.contractEndDate = null
    },
    contractStartDate(val, od){
      if (val){
        const pm = this.data.contractPeriod? this.data.contractPeriod:0
        const dt = this.$strToDate(val)
        dt.setMonth(dt.getMonth() + parseInt(pm))
        this.data.contractEndDate = this.formatter.fdate(dt)
      }
      //else this.data.contractEndDate = null
    },
    probationMonth(val, od){
      if(val){
      this.data.probationMonth = val
        const pm = val >0? val:0
        const dt = this.$strToDate(this.data.arriveDate)
        dt.setMonth(dt.getMonth() + parseInt(pm))
        this.data.probationEndDate = this.formatter.fdate(dt)
      }
      //else this.data.probationEndDate = null
    },
    arriveDate(val, od){
      if(val){
        const pm = this.data.probationMonth? this.data.probationMonth:0
        const dt = this.$strToDate(val)
        dt.setMonth(dt.getMonth() + parseInt(pm))
        this.data.probationEndDate = this.formatter.fdate(dt)
      }
     // else this.data.probationEndDate = null
    },
    companyNo(val, od){
      const cmp = this.config.company.filter(d=>{
        return d.value == val
      })
      if (cmp && cmp[0]){
        this.data.companyNo = cmp[0].value
        this.data.companyName = cmp[0].text
      }
      if ((this.action == "Add" || this.action == "Copy") && val!=od){
       this.$getData(this.config.url + "GetBh?cno="+val, this.rcBh)    
      }

    }
  },
  methods: {
    regCard(){
      this.showIC = true
    },
    closeIC(){
      this.showIC = false
    },
    initDept(deptNo){
      this.$getData(
        this.config.url + "initDept?deptNo=" + deptNo,
        (data)=>{
          if (data && data.rs) {
            this.xgroup = data.xgroup
            this.xjob = data.xjob
          }
        }
      )
    },
    rcBh(data){
      if (data.rs ==1){
        this.data.empId=data.empId 
        let empId = data.empId.toString()
        while (empId.length<6) empId = "0" + empId
        this.data.empNo = empId 
      }
    },
    readCard() {
      if (!this.ws) {
        const wsImpl = window.WebSocket || window.MozWebSocket;
        this.ws = new wsImpl("ws://localhost:9527/");

        this.ws.onmessage = evt => {
          let rs = 0,
            msg;
          if (evt.data == 11) {
            rs = 11;
            msg = "身份证读卡器连接失败，请检查读卡器是否正常！";
          } else if (evt.data == 12 || evt.data == 13) {
            rs = 12;
            msg =
              "读卡器端口打开失败，请检查读卡器是否正常，并重新连接读卡器！ code:" +
              evt.data;
          } else if (evt.data == 14 || evt.data == 15) {
            rs = 14;
            msg =
              "无法识别身份证，请检查身份证是否正确放置在读卡器上！ code:" +
              evt.data;
          } else if (evt.data == 16) {
            rs = 16;
            msg =
              "读取身份证信息失败，请重试！\r\n 如果重试仍未能读取身份证信息，则身份证芯片可能已经损坏！";
          } else if (evt.data.indexOf("{") == 0) {
            this.ws.close();
            const dt = JSON.parse(evt.data);
            console.log(dt.Sex)
            this.data.empName = dt.Name;
            this.data.sex = dt.Sex==1 ? 1 : 2 ;
            this.data.nation = dt.Nation;
            this.data.birthday = dt.Born;
            this.data.address = dt.Address;
            this.data.idCardNo = dt.IDCardNo;
            this.data.periodOfValidity = dt.UserLifeEnd;
            this.data.native = dt.jg; 
            
            this.showTabs = 3
            if (this.$confirm("身份证读取成功,是否用身份证头像替换当前员工头像？")){
              this.data.photo = "data:image/png;base64," + dt.photo
              this.imgPath = this.data.photo
            }
          }
          if (rs) this.$alert(msg);
        };
        this.ws.onopen = () => {
          this.ws.send("getIDCard");
        };
        this.ws.onclose = () => {
          this.ws = null;
        };
        this.ws.onerror = () => {
          this.$alert("服务连接失败，请检查服务是否已打开！");
        };
      } else {
        this.ws.send("getIDCard");
      }
    },
    fIDDate(dt) {
      return (
        dt.substring(0, 4) + "-" + dt.substring(4, 6) + "-" + dt.substring(6, 8)
      );
    },
    cFinger() {
      this.$getData(
        this.config.url + "GetFingerprint?bh=" + this.data.empId,
        this.openCFinger
      );
    },
    openCFinger(data) {
      if (data && data.rs) {
        this.fingerList = data.list;
        this.showFinger = 1;
      }
    },
    closeFinger() {
      this.showFinger = 0;
    },
    takePhoto() {
      this.showTakePhoto = 1
      if (!this.uimg) this.uimg = this.$refs.tph.$refs.uImg
      this.initWS("getImage")
      this.ws.onmessage = (ev)=>{
          this.uimg.src = ev.data
        }
      //this.$refs.tph.openWS()
    },
    closeTakePhoto() {
      if (this.ws && this.ws.readyState == 1) this.ws.send("closeImage")
      if (this.ws) this.ws.close()
      this.showTakePhoto = 0;
    },
    initWS(init){
      if (!this.ws || (this.ws && this.ws.readyState != 1)){
        const wsImpl = window.WebSocket || window.MozWebSocket
        this.ws = new wsImpl('ws://localhost:9527/')
        this.ws.onmessage = (ev)=>{
          uimg.src = ev.data
        }
        this.ws.onopen = ()=> {
          this.ws.send(init)
        }
        this.ws.onclose = ()=>{
          this.ws = null
        }
        this.ws.onerror = ()=>{
          this.$alert("服务连接失败，请检查服务是否已打开！")
        }
      }
      else{
        this.ws.send(init)
      }
    },
    bmChange() {
      this.data.deptName = this.config.dept.find(
        item => item.bmbh === this.data.deptNo
      ).bmmc;
    },
    checkInput() {},
    save: function() {
      //alert(123);
      this.checkInput();
      if (this.$trim(this.$refs.imgFile.value) != "") {
        const img = this.$refs.mImg;
        let str = this.getBase64Image(img);
        this.data.photo = str;
      }
      if (this.data.groupNo) {
        const gp = this.config.bz.find(item=>item.groupNo==this.data.groupNo)
        if(gp) this.data.groupName = gp.groupName
      }
      else this.data.groupName = null

       if (this.data.groupNo_B) {
        const gpB = this.config.bz.find(item=>item.groupNo==this.data.groupNo_B)
        if(gpB) this.data.groupName_B = gpB.groupName
      }
      else this.data.groupName_B = null

      if (this.data.shiftNo) {
        const shift = this.config.bc.find(item=>item.shiftNo==this.data.shiftNo)
        if (shift) this.data.shiftName=shift.shiftName
      }
      else this.data.shiftName=null



      if (this.data.planNo) this.data.planName=this.config.plan.find(item=>item.planNo==this.data.planNo).planName
      else this.data.planName=null

      if (this.data.accessControlNo) this.data.accessControlName=this.config.accessControl.find(item=>item.planNo==this.data.accessControlNo).planName
      else this.data.accessControlName=null

      if (!this.data.idCardNo) this.data.idCardNo = " "
      else this.data.idCardNo = this.$trim(this.data.idCardNo)
      if (this.data.empName) this.data.empName = this.$trim(this.data.empName)
      if (this.data.phone) this.data.phone = this.$trim(this.data.phone)
      this.data.bp = null

      if (this.action == "Add" || this.action == "Copy") {
        this.$save(this.url + "Add", this.data, this.saveResult);
      } else if (this.action == "Edit") {
        this.$save(this.url + "Edit", this.data, this.saveResult);
      }
    },
    setShowTabs(idx) {
      this.showTabs = idx;
    },
    selImg(e) {
      if ($.trim(e.target.value) != "")
        this.imgPath = window.URL.createObjectURL(e.target.files[0]);
      else this.imgPath = "";
    },
    getBase64Image(img) {
      const canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0, img.width, img.height);
      const dataURL = canvas.toDataURL("image/png");
      return dataURL; // return dataURL.replace("data:image/png;base64,", "");
    }
  },
  mixins: [mixin.detail],
  components: {
    takePhoto,
    fingerprint,
    icCard
  }
};
</script>

<style>
.poto-panel {
  float: right;
  margin-right: 10px;
  width: 200px;
  height: 250px;
}
.poto-panel > img {
  width: 200px;
  height: 230px;
}
.poto-panel > input {
  margin-top: 15px;
  width: 200px;
}
hr {
  margin-top: 10px;
  margin-bottom: 10px;
}

.detail-panel ul {
  list-style-type: none;
  margin-left: -40px;
}
.btn-panel {
  margin-top: 10px;
  margin-left: 10px;
}
.detail-panel ul > li {
  height: 40px;
}
.btn-panel > a {
  margin-left: 10px;
}
.tabs {
  width: 100%;
  height: 400px;
  background-color: #555;
}
tabs > ul {
  margin-top: 10px;
}
.fui-violet .tabs,
.fui-violet .nav-tabs>li.active>a, 
.fui-violet .nav-tabs>li.active>a:focus,
.fui-violet .nav-tabs>li.active>a:hover {
  background-color: #DCC8D2;
}

.fui-violet #empTabs .emp-tabs,
.fui-violet .nav-tabs>li.active>a, 
.fui-violet .nav-tabs>li.active>a:focus,
.fui-violet .nav-tabs>li.active>a:hover,
.fui-violet .nav-tabs>li>a:hover{
  color: #000 !important;
}
.fui-violet .nav-tabs>li>a:hover {
  background-color: #D4A5BD !important;
}
/*-----------------*/

.fui-blue .tabs,
.fui-blue .nav-tabs>li.active>a, 
.fui-blue .nav-tabs>li.active>a:focus,
.fui-blue .nav-tabs>li.active>a:hover {
  background-color: #AAC4DE;
}

.fui-blue #empTabs .emp-tabs,
.fui-blue .nav-tabs>li.active>a, 
.fui-blue .nav-tabs>li.active>a:focus,
.fui-blue .nav-tabs>li.active>a:hover,
.fui-blue .nav-tabs>li>a:hover{
  color: #000 !important;
}
.fui-blue .nav-tabs>li>a:hover {
  background-color: #C0C4F3 !important;
}
/*-----------------*/

.fui-green .tabs,
.fui-green .nav-tabs>li.active>a, 
.fui-green .nav-tabs>li.active>a:focus,
.fui-green .nav-tabs>li.active>a:hover,
.fui-green .nav-tabs>li.active>a:hover  {
  background-color: #B0D2B1;
}

.fui-green #empTabs .emp-tabs,
.fui-green .nav-tabs>li.active>a, 
.fui-green .nav-tabs>li.active>a:focus,
.fui-green .nav-tabs>li.active>a:hover,
.fui-green .nav-tabs>li>a:hover{
  color: #000 !important;
}
.fui-green .nav-tabs>li>a:hover {
  background-color: rgb(144, 247, 153) !important;
}

</style>
